module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isState),
      expression: "!isState"
    }],
    staticClass: "loginEwm"
  }, [(_vm.ewmUrl == '') ? _c('div', {
    staticClass: "waitMask"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "#1989fa"
    }
  }), _vm._v(" "), _c('p', [_vm._v("二维码生成中...")])], 1) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.ewmUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("请使用补偿本人的交管12123App扫一扫登录（补偿还需要获取您的驾考信息作为凭证，请尽快完成扫码登录，二维码会在3分钟后失效哦）")])]), _vm._v(" "), (_vm.processFlag) ? _c('div', {
    staticClass: "process"
  }, [_c('van-progress', {
    attrs: {
      "percentage": _vm.processNum,
      "stroke-width": "8"
    }
  }), _vm._v(" "), _vm._m(0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isState),
      expression: "isState"
    }],
    staticClass: "stateDiv"
  }, [(_vm.stateType == 1) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/success.png"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/error.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.stateType == 1) ? _c('p', {
    staticClass: "desc"
  }, [_vm._v("补偿申请成功")]) : _c('p', {
    staticClass: "desc"
  }, [_vm._v("补偿申请失败"), _c('span', [_vm._v(_vm._s(_vm.errorDesc))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red",
      "margin": "20px 0px"
    }
  }, [_vm._v("如果二维码超过一分钟未加载，请点击重新获取二维码")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%",
      "margin-top": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getLoginImage
    }
  }, [_vm._v("重新获取二维码")]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tips"
  }, [_vm._v("系统正在自动获取驾考信息，请您耐心等待，"), _c('br'), _vm._v("不要关闭当前页面！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4d04b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 474
// module chunks = 1